module.exports = __webpack_public_path__ + "img/filter-icon.dad00cd5.svg";